import { TranslationSet } from './en';

// TODO: translate values from English
export const it: TranslationSet = {
  '(From Now)': '(Da adesso)',
  '(From Scheduled)': '(Dal programmato)',
  '{amount} Off. Expires: {expires}.': '{amount} Disattivato. Scadenza: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'Un rapporto dettagliato che mostra ciascuna attività e il tempo impiegato da un tecnico o da un membro del personale tra e presso ciascun sito, con il tempo totale trascorso presso il sito.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'Un tipo di servizio con l\'ispezione abilitata verrà visualizzato nell\'elenco "da ispezionare" sul dispositivo mobile. Viene utilizzato anche nel reporting.',
  'Accept Invite': 'Accetta invito',
  'Add Condition': 'Aggiungi condizione',
  'Add deficiencies to the equipment type': 'Aggiungi carenze al tipo di attrezzatura',
  'Add Deficiency': 'Aggiungi carenza',
  'Add Equipment Field': 'Aggiungi campo Attrezzatura',
  'Add Equipment Type': 'Aggiungi tipo di attrezzatura',
  'Add Equipment': 'Aggiungi attrezzatura',
  'Add Floor Plan': 'Aggiungi planimetria',
  'Add history by clicking the plus in the top right or by performing a service.': 'Aggiungi la cronologia facendo clic sul segno più in alto a destra o eseguendo un servizio.',
  'Add History': 'Aggiungi cronologia',
  'Add Model Field': 'Aggiungi campo modello',
  'Add Model': 'Aggiungi modello',
  'Add Option': 'Aggiungi opzione',
  'Add Question': 'Aggiungi domanda',
  'Add questions using the plus icon in the top right': 'Aggiungi domande utilizzando l\'icona più in alto a destra',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'Aggiungi le categorie dei mesi di servizio in Impostazioni > Categorie dei mesi di servizio. I mesi di servizio ti consentono di conservare diversi tipi di apparecchiature in mesi selezionati per ciascuna sede. Esempio: Allarmi a maggio e ottobre ed Estintori a dicembre.',
  'Add Service Month Category': 'Aggiungi la categoria Mese di servizio',
  'Add Service Type': 'Aggiungi tipo di servizio',
  'Add service types in the settings': 'Aggiungi tipi di servizio nelle impostazioni',
  'Add service types using the plus icon in the top right': 'Aggiungi tipi di servizio utilizzando l\'icona più in alto a destra',
  'Add services to the equipment type': 'Aggiungi servizi al tipo di attrezzatura',
  'Add site Field': 'Aggiungi campo sito',
  'Add Site Override': 'Aggiungi la sostituzione del sito',
  'Add Site Type': 'Aggiungi tipo di sito',
  'Add Site': 'Aggiungi sito',
  'Add Sites': 'Aggiungi siti',
  'Add User': 'Aggiungi utente',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'Aggiungi i tuoi campi in Impostazioni > Campi personalizzati > Campi del sito',
  'Add': 'Aggiungi',
  'Adding': 'Aggiunta',
  'Address': 'Indirizzo',
  'Advance from Now': 'Anticipo da adesso',
  'Advance from Scheduled': 'Anticipo rispetto al programmato',
  'Agree': 'D\'accordo',
  'All Sites Scheduled!': 'Tutti i siti in programma!',
  'All': 'Tutto',
  'Already have an account? Login': 'Hai già un account? Accedi',
  'An error happened while syncing': 'Si è verificato un errore durante la sincronizzazione',
  'April': 'aprile',
  'August': 'Agosto',
  'Back': 'Indietro',
  'Billing Portal': 'Portale di fatturazione',
  'Building Reports': 'Rapporti sulla costruzione',
  'Cancel Plan': 'Annulla piano',
  'Cancel Subscription': 'Annulla abbonamento',
  'Cancel': 'Annulla',
  'Change Model Fields': 'Modifica campi modello',
  'Change Password': 'Cambia password',
  'Checklist Information': 'Informazioni sulla lista di controllo',
  'Checklist Question': 'Domanda sulla lista di controllo',
  'Checklist': 'Lista di controllo',
  'Choose File': 'Scegli File',
  'City': 'Città',
  'Clear All Data': 'Cancella tutti i dati',
  'Clear': 'Chiaro',
  'Click or tap to add location': 'Fare clic o toccare per aggiungere la posizione',
  'Close': 'Chiudi',
  'Company-Wide Reports': 'Report a livello aziendale',
  'Conditions': 'Condizioni',
  'Contact': 'Contatto',
  'Copy Barcode': 'Copia codice a barre',
  'Could not access': 'Impossibile accedere',
  'Could not find equipment with the scanned barcode': 'Impossibile trovare l\'attrezzatura con il codice a barre scansionato',
  'Could Not Service': 'Impossibile eseguire il servizio',
  'Create': 'Crea',
  'Creating Your Account': 'Creazione del tuo account',
  'Credentials are not valid': 'Le credenziali non sono valide',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'Campi dell\'attrezzatura personalizzata',
  'Custom Fields': 'Campi personalizzati',
  'Custom Model Fields': 'Campi del modello personalizzato',
  'Custom site Fields': 'Campi del sito personalizzato',
  'Date': 'Data',
  'Debug': 'Debug',
  'December': 'Dicembre',
  'Deficiencies': 'Carenze',
  'Deficiency Report': 'Rapporto sulle carenze',
  'Deficiency': 'Carenza',
  'Delete Equipment Field?': 'Eliminare il campo Attrezzatura?',
  'Delete Equipment Type?': 'Eliminare il tipo di attrezzatura?',
  'Delete Equipment Type': 'Elimina tipo di attrezzatura',
  'Delete Equipment?': 'Eliminare l\'attrezzatura?',
  'Delete Equipment': 'Elimina attrezzatura',
  'Delete Floor Plan?': 'Eliminare la planimetria?',
  'Delete Model Field?': 'Eliminare il campo del modello?',
  'Delete Model?': 'Eliminare il modello?',
  'Delete Model': 'Elimina modello',
  'Delete Override': 'Elimina sostituzione',
  'Delete Question?': 'Eliminare la domanda?',
  'Delete Question': 'Elimina domanda',
  'Delete Record?': 'Eliminare la registrazione?',
  'Delete Service Month?': 'Eliminare il mese del servizio?',
  'Delete Service Type?': 'Eliminare il tipo di servizio?',
  'Delete Site Field?': 'Eliminare il campo del sito?',
  'Delete Site Type?': 'Eliminare il tipo di sito?',
  'Delete Site?': 'Eliminare il sito?',
  'Delete Site': 'Elimina sito',
  'Delete User?': 'Eliminare l\'utente?',
  'Delete User': 'Elimina utente',
  'Delete': 'Elimina',
  'Deleted Equipment Field': 'Campo Attrezzatura eliminato',
  'Deleted Equipment': 'Attrezzatura eliminata',
  'Deleted Floor Plan': 'Planimetria eliminata',
  'Deleted Model Field': 'Campo modello eliminato',
  'Deleted Record': 'Registrazione eliminata',
  'Deleted Service Month': 'Mese di servizio eliminato',
  'Deleted Service Type': 'Tipo di servizio eliminato',
  'Deleted Site Field': 'Campo sito eliminato',
  'Deleted Site Type': 'Tipo di sito eliminato',
  'Detailed': 'Dettagliato',
  'Did not want done': 'Non volevo che fosse fatto',
  'Done by others': 'Fatto da altri',
  'Don\'t have an account? Sign Up': 'Non hai un account? Iscriviti',
  'Done': 'Fatto',
  'Edit Dates': 'Modifica date',
  'Edit Equipment': 'Modifica attrezzatura',
  'Edit': 'Modifica',
  'Email is not valid': 'L\'e-mail non è valida',
  'End Date': 'Data di fine',
  'Enter your email address': 'Inserisci il tuo indirizzo email',
  'Equipment already has this barcode': 'L\'apparecchiatura dispone già di questo codice a barre',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'L\'attrezzatura può essere qualsiasi cosa, da un estintore a un tapis roulant. Configura i tipi di attrezzatura in Impostazioni > Tipi di attrezzatura.s',
  'Equipment Deleted': 'Attrezzatura eliminata',
  'Equipment Due Consolidated Report': 'Rapporto consolidato Equipment Due',
  'Equipment Due Report': 'Rapporto sulla scadenza dell\'attrezzatura',
  'Equipment Field Information': 'Informazioni sul campo dell\'attrezzatura',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'I campi Attrezzatura consentono di aggiungere diversi campi aggiuntivi sul tipo di attrezzatura, come "Tensione" o "Km".',
  'Equipment Fields': 'Campi dell\'attrezzatura',
  'Equipment for a site with all scheduled services.': 'Attrezzature per un sito con tutti i servizi di linea.',
  'Equipment Options': 'Opzioni dell\'attrezzatura',
  'Equipment Report': 'Rapporto sull\'attrezzatura',
  'Equipment Service Report': 'Rapporto di servizio dell\'attrezzatura',
  'Equipment SKU': 'SKU dell\'attrezzatura',
  'Equipment Type Deleted': 'Tipo di attrezzatura eliminato',
  'Equipment Type': 'Tipo di attrezzatura',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'I tipi di attrezzatura aggiungono rapidamente definizioni di ispezione e servizio all\'attrezzatura quando viene selezionato un modello che la contiene. Esempi: estintore, tapis roulant, camion',
  'Equipment Types': 'Tipi di apparecchiature',
  'Equipment': 'Attrezzatura',
  'Export Billing Data': 'Esporta dati di fatturazione',
  'Export Data': 'Esporta dati',
  'Export': 'Esportazione',
  'Failed to load organization.': 'Impossibile caricare l\'organizzazione.',
  'Failed to save the organization.': 'Impossibile salvare l\'organizzazione.',
  'February': 'Febbraio',
  'Fill out the options below to prepare your report.': 'Compila le opzioni seguenti per preparare il tuo rapporto.',
  'Filter By': 'Filtra per',
  'FlameTask Basic Subscription': 'Abbonamento FlameTask Base',
  'FlameTask Enterprise Subscription': 'Abbonamento FlameTask Enterprise',
  'FlameTask Pro Subscription': 'Abbonamento FlameTask Pro',
  'Floor Plan Location': 'Posizione della planimetria',
  'Floor Plan': 'Pianta del piano',
  'Floor Plans': 'Planimetrie',
  'Force Error': 'Errore di forza',
  'Forgot Password': 'Password dimenticata',
  'Generate': 'Genera',
  'Hide "added" history records': 'Nascondi i record della cronologia "aggiunti".',
  'Hide Advanced': 'Nascondi Avanzate',
  'History': 'Storia',
  'How long a user spent at a site with time between actions.': 'Quanto tempo un utente ha trascorso su un sito con il tempo tra le azioni.',
  'If this email matched an account, a link was sent to reset your password.': 'Se questa email corrispondeva a un account, è stato inviato un collegamento per reimpostare la password.',
  'Import Data': 'Importa dati',
  'Import': 'Importa',
  'Inspection Due': 'Ispezione dovuta',
  'Inspection Report': 'Rapporto di ispezione',
  'Inspection': 'Ispezione',
  'Inspections are up to date': 'Le ispezioni sono aggiornate',
  'January': 'Gennaio',
  'July': 'Luglio',
  'June': 'Giugno',
  'Leave': 'Lascia',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'Elenco di tutte le apparecchiature presso il sito con opzioni per mostrare i servizi e filtrarli in base alla dovuta assistenza e/o ispezione.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'Elenco di tutti i siti con le relative informazioni. Opzioni per filtrare in base allo stato e al mese di servizio per trovare quali siti vengono serviti in un mese specifico.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'Elenco delle attrezzature e delle carenze nel sito, filtrato per attrezzature con carenze che hanno una data di apertura e nessuna data di chiusura.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'Elenco delle attrezzature compreso in un intervallo di date con risposte alle domande poste durante l\'esecuzione di un servizio o di un\'ispezione.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'Elenco delle attrezzature per un sito con informazioni importanti come la data dell\'ultima ispezione e la prossima manutenzione prevista, evidenziando in rosso le attrezzature da sottoporre a ispezione.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'Elenco delle apparecchiature che soddisfano i criteri di ricerca del modello. Esempio: un elenco di 5 attrezzature con informazioni sul modello corrispondenti a 6LB ABC DRY.',
  'Loading Equipment': 'Attrezzatura da carico',
  'Loading Models...': 'Caricamento modelli...',
  'Loading Scheduled Services...': 'Caricamento servizi pianificati...',
  'Loading Scheduled Sites': 'Caricamento siti pianificati',
  'Loading Service Types...': 'Caricamento tipi di servizio...',
  'Loading Sites': 'Caricamento siti',
  'Loading Unscheduled Services...': 'Caricamento servizi non pianificati...',
  'Loading...': 'Caricamento...',
  'Location': 'Posizione',
  'Logging in...': 'Accesso...',
  'Login Failed': 'Accesso non riuscito',
  'Login': 'Accedi',
  'Logout': 'Esci',
  'March': 'Marzo',
  'May': 'Maggio',
  'Meter Based Condition': 'Condizione basata sul contatore',
  'Model Deleted': 'Modello eliminato',
  'Model Field Information': 'Informazioni sul campo del modello',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'I campi del modello consentono di descrivere e riferire sull\'attrezzatura come "Taglia", "Tipo" e "Categoria".',
  'Model Fields': 'Campi modello',
  'Model Information': 'Informazioni sul modello',
  'Model Name': 'Nome del modello',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'I modelli consentono di aggiungere rapidamente informazioni alle apparecchiature, ad esempio il tipo di apparecchiatura/servizi a cui appartengono.',
  'Models': 'Modelli',
  'Months of History (to start of month)': 'Mesi di cronologia (all\'inizio del mese)',
  'More Details': 'Maggiori dettagli',
  'Name': 'Nome',
  'Nevermind': 'Non importa',
  'No Custom Equipment Fields': 'Nessun campo per l\'attrezzatura personalizzata',
  'No Deficiencies': 'Nessuna carenza',
  'No Equipment Fields': 'Nessun campo attrezzatura',
  'No Equipment Types': 'Nessun tipo di attrezzatura',
  'No Equipment': 'Nessuna attrezzatura',
  'No Floor Plans': 'Nessuna planimetria',
  'No History': 'Nessuna storia',
  'No Model Fields': 'Nessun campo modello',
  'No Models': 'Nessun modello',
  'No Open Deficiencies': 'Nessuna carenza aperta',
  'No Open or Closed Issues': 'Nessun problema aperto o chiuso',
  'No overrides for this Site': 'Nessuna sostituzione per questo sito',
  'No Questions': 'Nessuna domanda',
  'No Scheduled Services': 'Nessun servizio programmato',
  'No Scheduled Sites': 'Nessun sito pianificato',
  'No Service Month Categories': 'Nessuna categoria del mese di servizio',
  'No Service Types': 'Nessun tipo di servizio',
  'No Site Fields': 'Nessun campo del sito',
  'No Site Types': 'Nessun tipo di sito',
  'No Sites': 'Nessun sito',
  'No Unscheduled Services': 'Nessun servizio non programmato',
  'No, Go Back': 'No, torna indietro',
  'No': 'No',
  'Not in at the time of inspection': 'Non presente al momento dell\'ispezione',
  'Nothing to Inspect': 'Niente da ispezionare',
  'Nothing to Service': 'Niente da riparare',
  'November': 'Novembre',
  'October': 'Ottobre',
  'Ok': 'Ok',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'Apri una carenza facendo clic sul segno più in alto a destra nel riquadro. Una volta risolto il problema, fai clic su di esso e imposta la data di chiusura.',
  'Open a deficiency by tapping Options > Add Deficiency': 'Apri una carenza toccando Opzioni > Aggiungi carenza',
  'Open Deficiencies': 'Carenze aperte',
  'Open Deficiency': 'Carenza aperta',
  'Open in Apple Maps': 'Apri in Mappe di Apple',
  'Open in Google Maps': 'Apri in Google Maps',
  'Open Settings': 'Apri Impostazioni',
  'Open': 'Aperto',
  'Optional: Add a deficiency if this option is selected.': 'Facoltativo: aggiungi una carenza se questa opzione è selezionata.',
  'Optional: This can be useful to set meter values easily': 'Opzionale: può essere utile per impostare facilmente i valori del contatore',
  'Organization': 'Organizzazione',
  'Outstanding Equipment': 'Attrezzatura eccezionale',
  'PDF': 'PDF',
  'Perform From Now': 'Esegui da adesso',
  'Perform From Scheduled': 'Esegui da pianificato',
  'Perform Service From Scheduled': 'Esegui il servizio da pianificato',
  'Perform Service': 'Eseguire il servizio',
  'Perform': 'Esegui',
  'Phone Number': 'Numero di telefono',
  'Please fill out all fields': 'Si prega di compilare tutti i campi',
  'Please give a reason': 'Per favore, fornisci una ragione',
  'Please select country first': 'Seleziona prima il paese',
  'Popup Note': 'Nota popup',
  'Preferences': 'Preferenze',
  'Preview Details': 'Dettagli anteprima',
  'Profile': 'Profilo',
  'Purchase Barcodes': 'Acquista codici a barre',
  'Question Deleted': 'Domanda eliminata',
  'Question Information': 'Informazioni sulla domanda',
  'Questionnaire Report': 'Rapporto sul questionario',
  'Questions': 'Domande',
  'Range End': 'Fine intervallo',
  'Range Start': 'Inizio della gamma',
  'Reactivate': 'Riattivare',
  'Remove': 'Rimuovi',
  'Replace Barcode': 'Sostituisci codice a barre',
  'Replace Equipment': 'Sostituire l\'attrezzatura',
  'Replaced equipment': 'Attrezzatura sostituita',
  'Report Date': 'Data del rapporto',
  'Reports': 'Rapporti',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'Risparmia tempo e riduci al minimo i rischi tracciando la posizione delle apparecchiature su una planimetria di questo sito',
  'Save': 'Salva',
  'Saving': 'Risparmiare',
  'Scan barcode to make changes': 'Scansiona il codice a barre per apportare modifiche',
  'Scan Barcode': 'Scansiona il codice a barre',
  'Scan': 'Scansione',
  'Schedule': 'Programma',
  'Scheduled Event': 'Evento programmato',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'Le definizioni dei servizi programmati possono essere aggiunte al tipo di attrezzatura in Impostazioni > Tipi di attrezzatura',
  'Scheduled': 'Programmato',
  'See More': 'Vedi di più',
  'Selecting an option will add a history record and remove it from the todo list': 'La selezione di un\'opzione aggiungerà un record della cronologia e lo rimuoverà dall\'elenco delle cose da fare',
  'Selective Equipment Report': 'Rapporto sull\'attrezzatura selettiva',
  'September': 'Settembre',
  'Service Due': 'Servizio dovuto',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'Le categorie dei mesi di servizio consentono di conservare diversi tipi di apparecchiature in diversi mesi. Ad esempio, potresti ispezionare gli estintori in agosto e maggio e gli allarmi in ottobre.',
  'Service Month Categories': 'Categorie del mese di servizio',
  'Service Month Category': 'Categoria del mese di servizio',
  'Service Month': 'Mese di servizio',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'I mesi di servizio ti consentono di conservare diversi tipi di apparecchiature in mesi selezionati per ciascun sito. Esempio: Allarmi a maggio e ottobre ed Estintori a dicembre.',
  'Service Months': 'Mesi di servizio',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'Le sostituzioni del servizio ti consentono di disabilitare un servizio o modificare la frequenza per un sito specifico',
  'Service Type Settings': 'Impostazioni del tipo di servizio',
  'Service Type': 'Tipo di servizio',
  'Service Types': 'Tipi di servizio',
  'Service': 'Servizio',
  'Services are up to date': 'I servizi sono aggiornati',
  'Services': 'Servizi',
  'Set answer to equipment field': 'Imposta la risposta al campo dell\'attrezzatura',
  'Settings': 'Impostazioni',
  'Show Advanced': 'Mostra Avanzate',
  'Show History Time': 'Mostra l\'ora della cronologia',
  'Show Inspections': 'Mostra ispezioni',
  'Show Questions / Answers': 'Mostra domande/risposte',
  'Show Services': 'Mostra Servizi',
  'Sign Up': 'Iscriviti',
  'Simulate Scan': 'Simula scansione',
  'Site Deleted': 'Sito eliminato',
  'Site Field Information': 'Informazioni sul campo del sito',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'I campi del sito ti permetteranno di inserire informazioni aggiuntive nel sito, come "Posizione del parcheggio".',
  'Site Fields': 'Campi del sito',
  'Site Information': 'Informazioni sul sito',
  'Site Report': 'Rapporto sul sito',
  'Site Reports': 'Rapporti sul sito',
  'Site Service Override': 'Override del servizio sito',
  'Site Service Overrides': 'Sostituzioni del servizio sito',
  'Site Service Settings': 'Impostazioni del servizio sito',
  'Site Settings': 'Impostazioni del sito',
  'Site Type': 'Tipo di sito',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'I tipi di sito consentono di modificare i tipi di servizio in base al sito. Ad esempio, solo i clienti mensili mostrerebbero l\'ispezione mensile.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'I tipi di sito consentono di avere diversi tipi di servizi in diversi tipi di siti. Ad esempio, potrebbe essere necessario effettuare ispezioni mensili in un sito e solo un\'ispezione annuale in un altro.',
  'Site Types': 'Tipi di sito',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'I siti possono aiutarti a organizzare l\'attrezzatura in luoghi come "Ufficio" o "Magazzino". Se gestisci un\'azienda di servizi, puoi aggiungere i tuoi clienti come siti. ',
  'Sites': 'Siti',
  'Start Date': 'Data di inizio',
  'Start Trial': 'Inizia la prova',
  'Status': 'Stato',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'Riepilogo dei servizi in un sito separato dalle informazioni sul modello. Esempio 5 Ispezioni mensili con informazioni sul modello 6LB DRY ABC.',
  'Swap Equipment': 'Scambiare l\'attrezzatura',
  'Swapped equipment': 'Attrezzatura scambiata',
  'TEST': 'PROVA',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'Il piano EMS è un piano scontato per servizi sanitari senza scopo di lucro o finanziati con fondi pubblici.  Scegli un altro piano se non soddisfi questi criteri',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'La nota popup viene utilizzata per ricordarti informazioni importanti relative alla posizione. Apparirà quando si apre la schermata della posizione.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'Non sono presenti siti non programmati con ispezioni, servizi o carenze in sospeso.',
  'There is no equipment at this site with this search criteria and due inspections': 'In questo sito non sono presenti apparecchiature con questi criteri di ricerca e le dovute ispezioni',
  'There is no equipment at this site with this search criteria and due service': 'In questo sito non sono presenti apparecchiature con questi criteri di ricerca e il servizio dovuto',
  'This Month': 'Questo mese',
  'Time at Site Detailed': 'Tempo al sito dettagliato',
  'Time at Site': 'Tempo sul sito',
  'Time Based Condition': 'Condizione basata sul tempo',
  'Today': 'Oggi',
  'Transfer Equipment': 'Attrezzatura per il trasferimento',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'Le definizioni dei servizi non pianificati possono essere aggiunte al tipo di attrezzatura in Impostazioni > Tipi di attrezzatura',
  'Unscheduled': 'Non programmato',
  'Updated barcode': 'Codice a barre aggiornato',
  'Used Equipment SKU': 'SKU di attrezzature usate',
  'Used for the billing export for new, swapped and replaced equipment.': 'Utilizzato per l\'esportazione della fatturazione per apparecchiature nuove, scambiate e sostituite.',
  'User Deleted': 'Utente eliminato',
  'User Information': 'Informazioni sull\'utente',
  'User': 'Utente',
  'Users': 'Utenti',
  'View on FloorPlan': 'Visualizza in planimetria',
  'View Terms': 'Visualizza i termini',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'Ogni volta che l\'attrezzatura viene scambiata, l\'esportazione della fatturazione incrementerà la quantità sotto questo SKU.',
  'Yes, Delete Equipment Field': 'Sì, elimina il campo Attrezzatura',
  'Yes, Delete Equipment Type': 'Sì, elimina il tipo di attrezzatura',
  'Yes, Delete Equipment': 'Sì, elimina l\'attrezzatura',
  'Yes, Delete Floor Plan': 'Sì, elimina planimetria',
  'Yes, Delete Model Field': 'Sì, elimina il campo modello',
  'Yes, Delete Model': 'Sì, elimina modello',
  'Yes, Delete Question': 'Sì, elimina domanda',
  'Yes, Delete Record': 'Sì, elimina record',
  'Yes, Delete Service Month': 'Sì, elimina il mese del servizio',
  'Yes, Delete Service Type': 'Sì, elimina il tipo di servizio',
  'Yes, Delete Site Field': 'Sì, elimina il campo del sito',
  'Yes, Delete Site Type': 'Sì, elimina tipo di sito',
  'Yes, Delete Site': 'Sì, elimina sito',
  'Yes, Delete User': 'Sì, elimina utente',
  'Zone': 'Zona',
  'Customer': 'Cliente',
  'Site': 'Sito',
  'All Sites': 'Tutti i siti',
  'Loading Customers': 'Caricamento clienti',
  'No Customers': 'Nessun cliente',
  'Add Customer': 'Aggiungi cliente',
  'Customers are groups of sites with billing information.': 'I clienti sono gruppi di siti con informazioni di fatturazione.',
  'Customers': 'Clienti',
  'Customer Information': 'Informazioni sul cliente',
  'Delete Customer': 'Elimina cliente',
  'Yes, Delete Customer': 'Sì, elimina cliente',
  'Delete Customer?': 'Eliminare il cliente?',
  'Customer Deleted': 'Cliente eliminato',
  'Create Customer': 'Crea cliente',
  'Assign Existing Customer': 'Assegnare cliente esistente',
  'Edit Customer': 'Modifica cliente',
  'Enter a serial number': 'Inserisci un numero di serie',
  'Remove Customer': 'Rimuovi cliente',
  'Find': 'Trova',
  'Sync Now': 'Sincronizza ora',
  'Syncing...': 'Sincronizzazione...',
  'Find equipment by serial number': 'Trova l\'attrezzatura in base al numero di serie',
  'Last successful upload was {formattedDate}': 'L\'ultimo caricamento riuscito è stato {formattedDate}',
  'Up to date as of {formattedDate}': 'Aggiornato al {formattedDate}',
  'Zones are used to group locations in the location report': 'Le zone vengono utilizzate per raggruppare le posizioni nel rapporto sulla posizione',

  'Account Number': 'Numero di conto',
  'Add Location Override': 'Aggiungi la sostituzione della posizione',
  'Add New Model': 'Aggiungi nuovo modello',
  'Add Site Field': 'Aggiungi campo sito',
  'Address Line 2': 'Riga indirizzo 2',
  'Agree to': 'Accetto',
  'All conditions are true': 'Tutte le condizioni sono vere',
  'All Permissions': 'Tutti i permessi',
  'Allow Text Input': 'Consenti immissione testo',
  'An email with the reset password link below has been sent to': 'È stata inviata un\'e-mail con il collegamento per reimpostare la password riportato di seguito',
  'An error ocurred while trying to show this page.': 'Si è verificato un errore durante il tentativo di visualizzare questa pagina.',
  'Any condition is true': 'Qualsiasi condizione è vera',
  'Background Color': 'Colore di sfondo',
  'Billing and customer controls': 'Fatturazione e controlli sui clienti',
  'Building Reports - Safety Scan': 'Rapporti di costruzione - Scansione di sicurezza',
  'Change Another Service': 'Cambia un altro servizio',
  'Choose Site': 'Scegli Sito',
  'click here': 'clicca qui',
  'Closed Date': 'Data di chiusura',
  'Closed Deficiencies': 'Carenze chiuse',
  'Company Information': 'Informazioni aziendali',
  'Company Name': 'Nome dell\'azienda',
  'Completing Sign Up': 'Completamento della registrazione',
  'Context ID': 'ID contesto',
  'Could not find equipment with that barcode': 'Impossibile trovare l\'attrezzatura con quel codice a barre',
  'Creating invite link...': 'Creazione del collegamento di invito...',
  'Current equipment failed to load': 'Impossibile caricare l\'attrezzatura attuale',
  'Data File': 'File di dati',
  'Data Origin': 'Origine dei dati',
  'Date affected by': 'Data interessata da',
  'Date Completed': 'Data di completamento',
  'Date Started': 'Data di inizio',
  'Delete equipment?': 'Eliminare l\'attrezzatura?',
  'Dev Environment': 'Ambiente di sviluppo',
  'Disabled For': 'Disabilitato per',
  'Disabled For Location': 'Disabilitato per posizione',
  'Do not change': 'Non cambiare',
  'Due When': 'Scadenza quando',
  'Edit Deficiencies': 'Modifica carenze',
  'Edit History': 'Modifica cronologia',
  'Edit Location': 'Modifica posizione',
  'Edit Schedule': 'Modifica pianificazione',
  'Edit Service': 'Modifica servizio',
  'Edit Settings': 'Modifica impostazioni',
  'End Time': 'Ora di fine',
  'Equal to': 'Uguale a',
  'Equipment Field': 'Campo dell\'attrezzatura',
  'Equipment replaced': 'Attrezzatura sostituita',
  'Equipment swapped': 'Attrezzatura scambiata',
  'Example: Broken Handle': 'Esempio: maniglia rotta',
  'Frequency Type': 'Tipo di frequenza',
  'Generate Reports': 'Genera report',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'Inizia consultando i nostri tutorial su YouTube o configurando il tuo account nelle impostazioni.',
  'Global Search': 'Ricerca globale',
  'Greater than': 'Maggiore di',
  'hasn&apos;t accepted their invite yet. You can': 'non ha ancora accettato il loro invito. ',
  'Include In Reports': 'Includi nei report',
  'landscape LetterHead': 'Intestazione orizzontale',
  'Last Date': 'Ultima data',
  'Last Date Minimum Granularity': 'Granularità minima dell\'ultima data',
  'Last Download': 'Ultimo download',
  'Last Upload': 'Ultimo caricamento',
  'Less than': 'Meno di',
  'Locations can only be added on a desktop browser': 'Le posizioni possono essere aggiunte solo su un browser desktop',
  'Looks like you never finished signing up': 'Sembra che tu non abbia mai finito di iscriverti',
  'Metered Condition': 'Condizione misurata',
  'Mobile Access': 'Accesso mobile',
  'Model Number': 'Numero di modello',
  'Next Date (Overide)': 'Data successiva (sostituisci)',
  'No Conditions': 'Nessuna condizione',
  'No Options': 'Nessuna opzione',
  'Not equal to': 'Non uguale a',
  'Opened Date': 'Data di apertura',
  'Option Selected': 'Opzione selezionata',
  'Perform On Scan': 'Esegui durante la scansione',
  'Please click the button below to start your free 3 month trial': 'Fai clic sul pulsante in basso per iniziare la prova gratuita di 3 mesi',
  'Please review the terms below': 'Si prega di rivedere i termini seguenti',
  'Portrait LetterHead': 'Intestazione verticale',
  'Postal Code': 'Codice Postale',
  'Powered By': 'Offerto da',
  'Preventive Maintenance': 'Manutenzione preventiva',
  'Profile Image': 'Immagine del profilo',
  'Receive marketing emails': 'Ricevi email di marketing',
  'Rivison Inc.': 'Rivison Inc.',
  'Search Sites...': 'Cerca siti...',
  'Serial Number': 'Numero di serie',
  'Service is Unscheduled': 'Il servizio non è programmato',
  'Service Options': 'Opzioni di servizio',
  'Service or Inspection Due': 'Servizio o ispezione dovuti',
  'Show All': 'Mostra tutto',
  'Show site selector in top corner': 'Mostra il selettore del sito nell\'angolo in alto',
  'Sign-Up Failed. Ensure the email is not already is use.': 'Registrazione non riuscita. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'Spiacenti, si è verificato un errore durante il tentativo di creare un collegamento di invito. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'Siamo spiacenti, sembra che tu sia offline. ',
  'Start Time': 'Ora di inizio',
  'Successfully updated profile': 'Profilo aggiornato con successo',
  'terms and conditions': 'Termini e Condizioni',
  'Text Input': 'Immissione di testo',
  'The date below is used to show history records only.': 'La data seguente viene utilizzata per mostrare solo i record della cronologia.',
  'This will just take a moment': 'Ci vorrà solo un momento',
  'Time Condition': 'Condizione temporale',
  'Time Zone': 'Fuso orario',
  'to generate another invite link.': 'per generare un altro collegamento di invito.',
  'Toggle Flashlight': 'Attiva/disattiva la torcia',
  'Type more characters to narrow the search further': 'Digita più caratteri per restringere ulteriormente la ricerca',
  'Use text answer for': 'Utilizza la risposta testuale per',
  'Version:': 'Versione:',
  'View Deficiencies': 'Visualizza le carenze',
  'View Equipment': 'Visualizza l\'attrezzatura',
  'View History': 'Visualizza cronologia',
  'View Location': 'Visualizza posizione',
  'View Schedule': 'Visualizza il programma',
  'View Service': 'Visualizza il servizio',
  'View Settings': 'Visualizza Impostazioni',
  'We hope to see you again.': 'Speriamo di rivederti.',
  'Web Login': 'Accesso Web',
  'Welcome,': 'Benvenuto,',
  'White Label': 'Etichetta Bianca',
  'Work Day End Time': 'Orario di fine giornata lavorativa',
  'Work Day Start Time': 'Orario di inizio della giornata lavorativa',
  'You must agree to the terms and conditions': 'È necessario accettare i termini e le condizioni',
  'Your Subscription Has Been Canceled': 'Il tuo abbonamento è stato annullato',
};
